<ng-content select="td-wb-linear-list-item-label" />
<div class="td-wb-linear-list-item__value" role="cell">
  <ng-content />
</div>
